import type { ImportKind } from '@klareospace/pharos-lib-types';
import type { TFunction } from 'i18next';

import { IMPORT_TYPE_CONFIGS } from '../config';

// ─── Utils ────────────────────────────────────────────────────────────────────

/**
 * Resolves the translated import-type label for a history row via `IMPORT_TYPE_CONFIGS` (the
 * single source of truth for `labelKey`). Falls back to the raw `kind` for a value with no
 * matching config, instead of an unresolved i18n key.
 */
export function resolveImportTypeLabel(t: TFunction, kind: ImportKind): string {
  const config = IMPORT_TYPE_CONFIGS.find((candidate) => candidate.type === kind);
  return config ? t(config.labelKey) : kind;
}
